import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import cx from '../../../../utils/cx';


const CounterWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    font-size: 1.5rem;
    width: 100px;
    .counterIcon {
        &:hover {
            cursor: pointer;
        }

        &.disabled {
            opacity: 0.5;
            cursor: initial;
        }
    }
`;

const CounterCount = styled.div`
    font-size: 2.5rem;
    font-weight: bold;
    padding: 0 0.5rem;
`;

interface IProps {
    disabled?: boolean;
    max?: number;
    min?: number;
    onChange?: (count: number) => void;
}

const Counter = (props: IProps) => {
    const MIN = React.useMemo(() => props.min || 1, [props.min]);
    const MAX = React.useMemo(() => props.max || 10, [props.max]);;
    const [count, setCount] = React.useState(MIN);

    const onChange = (count: number) => {
        setCount(count);
        props.onChange?.(count);
    }

    const addOne = () => {
        if (count < MAX && !props.disabled) {
            onChange(count + 1);
        }
    };
    const minusOne = () => {
        if (count > MIN && !props.disabled) {
            onChange(count - 1);
        }
    }

    return (
        <CounterWrapper>
            <FontAwesomeIcon
                icon={faMinus}
                onClick={minusOne}
                className={cx({ counterIcon: true, disabled: count == MIN })} />
            <CounterCount>{count}</CounterCount>
            <FontAwesomeIcon
                icon={faPlus}
                onClick={addOne}
                className={cx({ counterIcon: true, disabled: count == MAX })} />
        </CounterWrapper>
    );
}

export default Counter;